<template>
  <div>
    <BlTabsMv :tabs="tabs" :active-tab-name.sync="activeTabName" class="mt-16" @update:activeTabName="onTabChange">
      <!-- Tab Lembaga -->
      <BlTabNavMv slot="tab-nav-merchants" title="Lembaga Pelatihan" />
      <BlTabContentMv slot="tab-content-merchants">
        <ListWithIconShimmer
          v-if="!highlightedMerchant.length && !isError.highlightedMerchant"
          :count="8"
          class="qa-shimmer-highlighted-merchants mt-20"
        />
        <template v-else>
          <ListWithIconError
            v-if="isError.highlightedMerchant && !isAppLoading"
            info="Yah, infonya belum berhasil dimuat. Silakan coba muat ulang, ya."
            @reload="fetchHighlightedMerchant"
          />

          <BlFlexContainerMv v-else padding="16px" wrap="wrap">
            <ListWithIcon :list="highlightedMerchant" more-button-link="merchants" class="qa-edu_karier-tab-content-merchants w-full" />
          </BlFlexContainerMv>
        </template>
      </BlTabContentMv>
      <!-- End of Tab Lembaga -->

      <!-- Tab Kategori -->
      <BlTabNavMv slot="tab-nav-category" title="Kategori Kelas" />
      <BlTabContentMv slot="tab-content-category">
        <ListWithIconShimmer v-if="!categoriesConfig.length && !isError.categoriesConfig" :count="8" class="mt-20" />

        <template v-else>
          <ListWithIconError
            v-if="isError.categoriesConfig"
            info="Yah, infonya belum berhasil dimuat. Silakan coba muat ulang, ya."
            @reload="fetchCategoriesConfig"
          />

          <BlFlexContainerMv v-else padding="16px" wrap="wrap">
            <ListWithIcon
              :list="categoriesConfig"
              :icon-size="40"
              more-button-link="categories"
              class="qa-edu_karier-tab-content-categories w-full"
            />
          </BlFlexContainerMv>
        </template>
      </BlTabContentMv>
      <!-- End of Tab Kategori -->
    </BlTabsMv>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {BlTabsMv, BlTabNavMv, BlTabContentMv} from '@bukalapak/bazaar-mweb-latest';

import ListWithIcon from './ListWithIcon.vue';
import ListWithIconShimmer from './ListWithIconShimmer.vue';
import ListWithIconError from './ListWithIconError.vue';

export default {
  name: 'CategoryAndMerchantTab',
  components: {
    BlTabsMv,
    BlTabNavMv,
    BlTabContentMv,
    ListWithIcon,
    ListWithIconShimmer,
    ListWithIconError,
  },
  data() {
    return {
      activeTabName: 'merchants',
      tabs: ['merchants', 'category'],
    };
  },
  computed: {
    ...mapGetters(['isAppLoading']),
    ...mapGetters({
      highlightedMerchant: 'merchants/getHighlightedMerchant',
      categoriesConfig: 'categories/getCategoriesConfig',
      isError: 'getError',
    }),
  },
  mounted() {
    this.fetchHighlightedMerchant();
  },
  methods: {
    fetchHighlightedMerchant() {
      this.$store.dispatch('merchants/fetchHighlightedMerchant');
    },
    onTabChange() {
      if (!this.categoriesConfig.length) this.fetchCategoriesConfig();
    },
    fetchCategoriesConfig() {
      this.$store.dispatch('categories/fetchCategoriesConfig');
    },
  },
};
</script>
